export default {
	URL: 'https://api-condominio.infinitum-ti.com',
	API_URL: 'https://api-condominio.infinitum-ti.com/api',
	OAPI_URL: 'https://api-condominio.infinitum-ti.com/oapi',
	// URL: 'http://localhost:2412',
	// API_URL: 'http://localhost:2412/api',
	// OAPI_URL: 'http://localhost:2412/oapi',
}
